import { useRouter } from '@tanstack/react-router';
import type { TripErrorType } from '@/api';
import cabErrorImage from '@/assets/api-error.png?url';
import cabExclamImage from '@/assets/api-warning.png?url';
import { ErrorLayout } from '@/components/error-states/Layout';
import { ApiFailed } from '@/components/icons';
import { useNavigate } from '@/lib/navigation';

interface ErrorConfig {
	image: React.ReactNode | string;
	btnText: string;
}

const TRIP_DETAIL_ERROR: Record<TripErrorType, ErrorConfig> = {
	INVALID_BOOKING_ID: {
		image: cabExclamImage,
		btnText: 'Go to Home',
	},
	RETURN_HOME: {
		image: cabExclamImage,
		btnText: 'Go to Home',
	},
	RETRY: {
		image: cabExclamImage,
		btnText: 'Refresh',
	},
	API_ERROR: {
		image: <ApiFailed />,
		btnText: 'Refresh',
	},
	GENERIC_ERROR: {
		image: cabErrorImage,
		btnText: 'Go to Home',
	},
};
export interface ErrorProps {
	title: string;
	description: string;
	errorType: TripErrorType;
	fullScreen?: boolean;
}

export const ErrorView = ({
	title,
	description,
	errorType = 'GENERIC_ERROR',
	fullScreen = false,
}: ErrorProps) => {
	const router = useRouter();
	const navigate = useNavigate();
	const { image, btnText } = TRIP_DETAIL_ERROR[errorType];

	return (
		<ErrorLayout
			title={title}
			description={description}
			buttonText={btnText}
			buttonProps={{
				onClick: () => {
					if (errorType === 'API_ERROR') {
						router.invalidate();
					} else {
						navigate({ to: '/', viewTransition: { types: ['slide-left'] } });
					}
				},
			}}
			fullScreen={fullScreen}
		>
			<div className="flex justify-center items-center">
				{typeof image === 'string' ? (
					<img src={image} alt="Error" className="size-100 object-contain" />
				) : (
					<div className="size-100 flex items-center justify-center">
						{image}
					</div>
				)}
			</div>
		</ErrorLayout>
	);
};
